/**
 * Withdrawing an issued prescription found to be wrong, from the prescriptions tile.
 *
 * An issued prescription is locked - it is never opened again, and a change is a new prescription - so
 * this small dialog shows which one it is and asks why. A withdrawn prescription stays on the patient's
 * record, marked withdrawn with the reason, and can no longer be dispensed.
 */
app.controller("lensRxWithdrawModalController", [
	"$scope",
	"$mdDialog",
	"LensPrescribingStore",
	"LensDispensingStore",
	"toast",
	"existingRx",
	"patientId",
	function ($scope, $mdDialog, Rx, Store, toast, existingRx, patientId) {
		$scope.R = Rx;
		$scope.p = existingRx;
		$scope.example = Rx.isContactsRx(existingRx) ? "Left power entered as -2.25, should be -2.75" : "Axis entered as 80, should be 180";
		$scope.withdrawing = { reason: "", busy: false };

		$scope.withdraw = function () {
			const reason = ($scope.withdrawing.reason || "").trim();
			if (!reason || $scope.withdrawing.busy || !Rx.isIssued(existingRx) || !Rx.canWithdraw()) return;
			$scope.withdrawing.busy = true;
			Rx.withdraw(patientId, existingRx, reason)
				.then(function (withdrawn) {
					toast.create({ timeout: 6000, message: "The prescription has been withdrawn. It can no longer be dispensed.", className: "alert-success", dismissible: true });
					$mdDialog.hide(withdrawn);
				})
				.catch((resp) => toast.create({ timeout: 6000, message: Store.errorMessage(resp, "The prescription could not be withdrawn."), className: "alert-danger", dismissible: true }))
				.finally(() => ($scope.withdrawing.busy = false));
		};

		$scope.cancel = () => $mdDialog.cancel();
	},
]);
